export default __webpack_public_path__ + "d8c83ba483cfc198e3eec225499c2c21.png";